import { AiSearchInput as AiSearch } from './ai-search-input/ai-search-input'

type AiSearchInputProps = {
  placeholders?: string[]
  showSubmitButton?: boolean
}

export const AiSearchInput = (props: AiSearchInputProps) => (
  <AiSearch
    aria-label={'AI powered search input'}
    placeholders={props.placeholders}
    showSubmitButton={props.showSubmitButton}
  />
)
